fx.ns("desktop.common.panels", class PhotoFilters extends fx.Component {

    constructor(model /*data, book*/)
    {
        super(/*data*/);

        this.model = model;
        this.data = model.photos;
        this._book = model.creation;
        this.listenUpdates(this._book);
    }

    set data(val)
	{
		if (val instanceof fx.ModelArray)
			super.data = val;
        else
        if (val)
		{
			this.model = val;
			this.data = val.photos;
            this._book = val.creation;
            
            if (this.selectSort)
                this.selectSort.selectedIndex = this._book.photosSort;

            if (this.checkboxUsed)
                this.checkboxUsed.value = !this._book.showphotosused;
		}
	}

    get photos()
    {
        return this.data;
    }


    create()
    {
        this.button = new fx.components.IconButton({icon : fx.get("assets").filterIcon, className : "sort"});
        this.addChild( this.button, {width : 40, height : 40});

        this.filterbox = new fx.components.VBox("filters");
        this.filterbox.toolTip = false;
        this.filterbox.effect = "vslide";
        this.filterbox.visibleAtStart = false;
        this.addChild(this.filterbox, {top : 0, left : 45, width:"320", height : "auto"});

        /*let photosorts = this.model.photosorts;
        photosorts[0].label = fx.text("Trier par ordre d'ajout");
        photosorts[1].label = fx.text("Trier par date de photo");
        photosorts[2].label = fx.text("Trier par personne");*/

        this.selectSort = new fx.components.CheckList({selectedIndex : this._book.photosSort, className : "sort-photos", items : this.model.photosorts });
        this.filterbox.addChild(this.selectSort, {width: "100%", height : "auto", left : 20})

        this.filterbox.addChild(new fx.components.Box("separator"), {width:"100%", height:1});
        
        let switchContainer = new fx.components.HBox();
        switchContainer.addChild(new fx.components.Text({className: "switchText", text: fx.text("Masquer les photos utilisées")}), {width: "70%", height: 30, left: 0});
        this.switchButton = new fx.components.SwitchButton({className: 'switchButton', value: !this._book.showphotosused});
        switchContainer.addChild(this.switchButton, {width: "20%", right:0});

        this.filterbox.addChild( switchContainer, {left : 20, width : "100%", height : 30});
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.model instanceof models.ProductBook && action.type == "init")
        {
            this.selectSort.selectedIndex = this._book.photosort;
            this.switchButton.switched = !this._book.showphotosused;
        }
    }
    
    onReady()
    {
        this.on("mousedown", this._onClick, window);
        this.on("changed", this._onSortChanged, this.selectSort);
        this.on("changed", this._onUsedChanged, this.switchButton);
    }


    selectFilter(index)
    {
        //this.selectSort.select(filter);
        this.selectSort.selectedIndex = index;
        this._book.photosort = this.selectSort.selectedIndex;
    }

    _onClick(e)
    {
        if ( fx.dom.parent(e.target, this.button) )
        {
            this.filterbox.toggle();
            this.button.toggleClass("active");
        }
            
        else
        if ( !fx.dom.parent(e.target, this.filterbox) )
        {
            this.filterbox.hide();
            this.button.removeClass("active");
        }
            
    }

    _onSortChanged(e)
    {
        this._book.photosort = this.selectSort.selectedIndex;
    }

    _onUsedChanged(e)
    {
        this._book.showphotosused = e.detail ? 0 : 1;
    }

});